'use client';

import { GlobalErrorPage } from '@/shared/presentation/components/global-error-page';

export default function GlobalError(props: { error: Error & { digest?: string } }) {
  return <GlobalErrorPage {...props} />;
}
